import { theme } from '@atlas/shared/client/ui/core/theming';
import { FontFamilyLrFontFamilyDefault } from '@laredoute/design-system/tokens';
import { css, unsafeCSS } from 'lit';

export const inputStyle = css`
    :host {
        --font-family: ${unsafeCSS(FontFamilyLrFontFamilyDefault)};
        --font-size: var(--lr-text-14);
        --border-color: var(--lr-border-color);
        --padding-y: var(--lr-py-12);
        --padding-x: var(--lr-px-8);
        --border-radius: var(--lr-border-radius);
        --height: 44px;
        --color: var(--lr-greys-900);
        --font-weight: var(--lr-font-600);
        --margin-bottom: var(--lr-my-4);
        --placeholder-color: var(--lr-greys-700);
        --caret-color: var(--lr-info-500);
        font-family: var(--font-family);
        position: relative;
        .input-wrapper {
            display: inline-block;
            position: relative;
            width: 100%;
        }
    }

    label {
        cursor: pointer;
        color: var(--color);
        font-weight: var(--font-weight);
        margin-bottom: var(--margin-bottom);
        font-family: var(--font-family);
        font-size: var(--font-size);
        margin-bottom: var(--lr-my-4);
    }

    :host input {
        color: var(--color);
        padding: var(--padding-y) var(--padding-x);
        border: 2px solid var(--border-color);
        border-radius: var(--border-radius);
        width: 100%;
        height: var(--height);
        transition: color 0.2s, background-color 0.2s, border-color 0.2s;
        box-shadow: none;
        -webkit-appearance: none;
        caret-color: var(--caret-color);
        &[disabled] {
            --color: var(--lr-field-color-disabled);
            --border-color: var(--lr-border-color-disabled);
            --border-color: var(--lr-border-color-disabled);
            background-color: ${unsafeCSS(theme.colors.semantic.fields.background.disabled)};
            -webkit-text-fill-color: var(--color);
            cursor: not-allowed;
        }

        &:not([disabled]) {
            &:hover {
                --border-color: var(--lr-border-color-hover);
            }
            &:not([active]) {
                &:focus {
                    --border-color: var(--lr-border-color-active);
                    &:not(:focus-visible) {
                        --border-color: var(--lr-border-color-active);
                    }
                }
            }
        }
    }

    /* Do not nest this ::placeholder value for browser compatibility */
    :host input::placeholder,
    :host input::-webkit-input-placeholder {
        font-family: var(--font-family);
        color: var(--placeholder-color);
    }

    :host .icon {
        position: absolute;
        top: calc(var(--height) - 40%);
        transform: translateY(calc(var(--height) - 100%));
        pointer-events: none;
    }

    :host([iconposition='left']) {
        input {
            padding-left: calc(var(--lr-px-44));
        }
        .icon {
            left: var(--lr-px-12);
        }
    }
    :host([iconposition='right']) {
        input {
            padding-right: calc(var(--lr-px-44));
        }
        .icon {
            right: 1rem;
        }
    }

    :host([size='small']) {
        --font-size: var(--lr-text-14);
    }
`;
